import React from 'react';

const FiltersSection = () => (
  <div className='pageHead-filters wrapper'>
    <div className='pageHead-filters-search'>
      <div className='input-group'>
        <input className='search-query form-control' type='text' placeholder='Ingresa el nº de chasis o nº pedido' /><span className='input-group-btn'>
          <button className='btn btn-default' type='button'><i className='ion-search' />
          </button></span>
      </div>
    </div>
    <div className='pageHead-filters-drops'>
      <div className='dropdown dropdown-multi'>
        <div className='dropdown-control' data-toggle='dropdown'>
          <input className='dropdown-control-input' />
          <label className='dropdown-control-fakelabel'><span>Ubicación</span><span className='dropdown-control-count' /></label>
          <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
        </div>
        <div className='dropdown-tooltip dropdown-menu'>
          <div className='dropdown-scroll'>
            <p>Ubicación</p>
            <ul>
              <li>
                <div className='checkbox'>
                  <label>
                    <input type='checkbox' />
                    <div className='checkbox-skin' />Carrocero
                  </label>
                </div>
              </li>
              <li>
                <div className='checkbox'>
                  <label>
                    <input type='checkbox' />
                    <div className='checkbox-skin' />Penalidad
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <div className='dropdown-acions'>
            <button className='btn btn-dark'>Filtrar</button>
          </div>
        </div>
      </div>
      <div className='dropdown dropdown-multi'>
        <div className='dropdown-control' data-toggle='dropdown'>
          <input className='dropdown-control-input' />
          <label className='dropdown-control-fakelabel'><span>Situación</span><span className='dropdown-control-count' /></label>
          <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
        </div>
        <div className='dropdown-tooltip dropdown-menu'>
          <div className='dropdown-scroll'>
            <p>Situación</p>
            <ul>
              <li>
                <div className='checkbox'>
                  <label>
                    <input type='checkbox' />
                    <div className='checkbox-skin' />Carrocero
                  </label>
                </div>
              </li>
              <li>
                <div className='checkbox'>
                  <label>
                    <input type='checkbox' />
                    <div className='checkbox-skin' />Penalidad
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <div className='dropdown-acions'>
            <button className='btn btn-dark'>Filtrar</button>
          </div>
        </div>
      </div>
      <div className='dropdown dropdown-multi'>
        <div className='dropdown-control' data-toggle='dropdown'>
          <input className='dropdown-control-input' />
          <label className='dropdown-control-fakelabel'><span>Etiquetado</span><span className='dropdown-control-count' /></label>
          <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
        </div>
        <div className='dropdown-tooltip dropdown-menu'>
          <div className='dropdown-scroll'>
            <p>Etiquetado</p>
            <ul>
              <li>
                <div className='checkbox'>
                  <label>
                    <input type='checkbox' />
                    <div className='checkbox-skin' />Autos
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <div className='dropdown-acions'>
            <button className='btn btn-dark'>Filtrar</button>
          </div>
        </div>
      </div>
      <button className='btn btn-default pageHead-filters-extra' data-toggle='modal' data-target='#moreFilters'>Más filtros</button>
    </div>
  </div>
);

export default FiltersSection;



// WEBPACK FOOTER //
// ./src/components/FichaLogistica/Etiquetado/FiltersSection.js